<section class="feedback-form">
  <p-card [styleClass]="'alternative-card'">
    <p-avatar
      icon="pi pi-info-circle"
      styleClass="mr-2"
      size="large"
      [styleClass]="'feedback-icon'"
    ></p-avatar>
    <p>{{ 'feedback.please-provide-feedback' | translate }}</p>
  </p-card>

  <div class="feedback-guidance">
    <p>
      <strong>{{ 'feedback.detailed-info-guidance' | translate }}</strong>
    </p>
    <ul>
      <li>{{ 'feedback.guidance-what-doing' | translate }}</li>
      <li>{{ 'feedback.guidance-where' | translate }}</li>
      <li>{{ 'feedback.guidance-what-happened' | translate }}</li>
      <li>{{ 'feedback.guidance-when' | translate }}</li>
      <li>{{ 'feedback.guidance-recur' | translate }}</li>
    </ul>
    <p>{{ 'feedback.attach-screenshot-guidance' | translate }}</p>
    <div class="screenshot-instructions">
      <p>
        <strong>{{
          'feedback.screenshot-instructions-title' | translate
        }}</strong>
      </p>
      <p>{{ 'feedback.screenshot-instructions-subtitle' | translate }}</p>
      <ul>
        <li>{{ 'feedback.screenshot-instructions-windows' | translate }}</li>
        <li>{{ 'feedback.screenshot-instructions-mac' | translate }}</li>
      </ul>
      <p>
        <em>{{ 'feedback.paste-screenshot-hint' | translate }}</em>
      </p>
    </div>
  </div>

  <form (ngSubmit)="postFeedback()" (paste)="onPaste($event)">
    <div class="form-row p-fluid field grid">
      <label for="title" class="col-fixed">
        {{ 'common.title' | translate }}
      </label>
      <input
        pInputText
        id="title"
        name="title"
        [(ngModel)]="title"
        class="input-bar"
        class="input-bar"
      />
    </div>
    <div class="form-row p-fluid field grid">
      <label for="description" class="col-fixed">
        {{ 'common.description' | translate }}
      </label>
      <textarea
        pInputTextarea
        id="description"
        name="description"
        [(ngModel)]="description"
        class="input-bar"
        class="input-bar"
        rows="5"
        cols="30"
      ></textarea>
    </div>
    <div class="p-fluid field grid">
      <label for="file" class="col-fixed">
        {{ 'common.file' | translate }}
      </label>
      <p-fileUpload
        id="file"
        #uploader
        [multiple]="true"
        [maxFileSize]="5000000"
        [fileLimit]="5"
        dragDropSupport="true"
        [showUploadButton]="false"
        [customUpload]="true"
        (onSelect)="onSelectFile($event, uploader)"
        [chooseLabel]="
          'healthrecords.healthrecord.choose-attachments' | translate
        "
        [cancelLabel]="
          'healthrecords.healthrecord.cancel-attachments' | translate
        "
        [invalidFileSizeMessageSummary]="
          'healthrecords.healthrecord.attachments-invalidFileSizeMessageSummary'
            | translate
        "
        [invalidFileSizeMessageDetail]="
          'healthrecords.healthrecord.attachments-invalidFileLimitMessageDetail'
            | translate
        "
        [invalidFileLimitMessageSummary]="
          'healthrecords.healthrecord.attachments-invalidFileLimitMessageSummary'
            | translate
        "
        [invalidFileLimitMessageDetail]="
          'healthrecords.healthrecord.attachments-invalidFileLimitMessageDetail'
            | translate
        "
        (onRemove)="onRemoveFile($event, uploader)"
        (onClear)="onClearFiles(uploader)"
        accept="image/*,application/pdf"
      >
      </p-fileUpload>
    </div>
    <p>{{ 'feedback.current-user-and-organization-data' | translate }}</p>

    <div>
      <ul class="fb-ul">
        <li class="fb-li">
          {{ 'feedback.location' | translate }}:
          {{ feedback.location }}
        </li>
        <li class="fb-li">
          {{ 'feedback.user-agent' | translate }}:
          {{ feedback.userAgent }}
        </li>
        <li class="fb-li">
          {{ 'feedback.screen-resolution' | translate }}:
          {{ feedback.screenResolution }}
        </li>
      </ul>
    </div>

    <div class="form-row grid feedback-buttons">
      <div class="p-m-3">
        <button pButton [type]="'submit'" class="p-button-primary">
          {{ 'common.button.save' | translate }}
        </button>
      </div>
      <span class="p-m-3">
        <button
          pButton
          [type]="'button'"
          (click)="doClose()"
          styleClass="p-button-secondary"
        >
          {{ 'common.button.cancel' | translate }}
        </button>
      </span>
    </div>
  </form>
</section>
